import { useEffect } from "react";
import TenantForm from "./TenantForm";

export default function TenantProfileModal({ tenant, hidden = false, onClose, ...formProps }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !hidden && !formProps.isSubmitting) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [formProps.isSubmitting, hidden, onClose]);

  const title = tenant ? "Tenant Profile" : "Create Tenant";

  return (
    <div
      className="admin-modal-backdrop"
      role="presentation"
      aria-hidden={hidden || undefined}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !hidden && !formProps.isSubmitting) onClose();
      }}
    >
      <section className="admin-modal admin-modal-wide" role="dialog" aria-modal={!hidden} aria-labelledby="tenant-profile-title">
        <div className="admin-modal-header">
          <div>
            <p className="admin-page-eyebrow">Mailbox Manager</p>
            <h2 id="tenant-profile-title">{title}</h2>
            <p>{tenant ? "Review or update this tenant's information." : "Enter the tenant's contact and address information."}</p>
          </div>
          <button className="admin-modal-close" type="button" aria-label={`Close ${title}`} onClick={onClose} disabled={formProps.isSubmitting}>
            &times;
          </button>
        </div>
        <TenantForm tenant={tenant} onCancel={onClose} {...formProps} />
      </section>
    </div>
  );
}
